import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
const _DisplayCard = forwardRef(({ children, padding = "normal", ...rest }, ref) => {
    return (_jsx(Container, { ...rest, ref: ref, "$padding": padding || "normal", children: children }));
});
export const DisplayCard = styled(_DisplayCard) ``;
const matchPadding = {
    normal: "sp24",
    small: "sp16",
    empty: "sp4",
};
const Container = styled.div `
  padding: ${({ $padding, theme }) => $padding === "empty" ? "0" : theme.spacing[matchPadding[$padding]]};
  background: ${({ theme }) => theme.systemColors.white};
  border: 1px solid ${({ theme }) => theme.systemColors.grey200};
  border-radius: 6px;
  outline: none;
  position: relative;
`;
